import { render } from "./UkraineComponent.vue?vue&type=template&id=316a5b4f"
import script from "./UkraineComponent.vue?vue&type=script&lang=js"
export * from "./UkraineComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/konradmilewski/Projects/AppWorks/janpawelvue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__